module.exports = __webpack_public_path__ + "media/images/photos/blue-7f2467e176f17b150f8b6da927d80a9e.jpg";